export interface DomeImage {
  src: string
  alt: string
}

/** Photography of the geodesic dome — the main gathering space. */
export const domeImages: DomeImage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/si58DhwUTRVDDXyowrNiAy/2.jpg',
    alt: 'An evening yoga class in the dome under warm lamp light',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/rZKjG5Ks6UL1TEaHebVdYD/1.jpg',
    alt: 'A full class moving through poses on mats inside the dome',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7PR6W8aKFajHMM3AYSY8dT/5.jpg',
    alt: 'The empty dome in daylight with a single mat on the rug',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/rRoWy9gzp3AD5YQF8xjNXU/3.jpg',
    alt: 'A group lying in stillness at the end of a session',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4KtUs4qZQ5rEHJQSmw6Fod/4.jpg',
    alt: 'A seated meditation circle facing the instruments',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/sWvm9mv4418jXg48MsR6We/6.jpg',
    alt: 'The dome set with floor cushions and a handpan for a sound session',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2QTbjaCqyDQL16Y4egM7oU/7.jpg',
    alt: 'The dome lit for a party with a DJ set up along the wall',
  },
]
